import { render, staticRenderFns } from "./PointsExtractPage.vue?vue&type=template&id=b4fa3522&scoped=true"
import script from "./PointsExtractPage.vue?vue&type=script&lang=js"
export * from "./PointsExtractPage.vue?vue&type=script&lang=js"
import style0 from "./PointsExtractPage.vue?vue&type=style&index=0&id=b4fa3522&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b4fa3522",
  null
  
)

export default component.exports